import React, { useState } from "react";
import icon1 from "../../assets/images/1.webp";
import icon2 from "../../assets/images/2.webp";
import icon3 from "../../assets/images/3.webp";
import icon4 from "../../assets/images/4.webp";
import { motion } from "motion/react";

type ExperienceType = {
  id: number;
  company: string;
  icon: string; // Icon for the company
  title: string;
  duration: string;
  role: string;
  content: React.ReactNode; // Unique content for each experience
};
const experience: ExperienceType[] = [
  {
    id: 1,
    company: "Sonendo, Inc.",
    icon: icon2,
    title: "Present Work",
    duration: "2022 - 2024",
    role: "Chief Financial Officer",
    content: (
      <>
        {/* <h2 className="text-secondary montserrat-bold text-xl mb-6">Profile</h2> */}
        <h3 className="text-primary montserrat-semibold text-xl mb-4">
          Chief Financial Officer: Sonendo, Inc.
        </h3>
        <p className="montserrat-regular mb-6">
          I led efforts to raise capital for the turnaround of an innovative
          technology platform focused on making root canal procedures more
          painless and effective. Working closely with the CEO and senior
          leadership, I drove commercial expansion, secured debt and equity
          capital, and planned the strategy for relisting on Nasdaq.
        </p>
        <ul className="montserrat-regular list-disc mb-4 sm:mb-7 ml-4 ">
          <li>Led capital raising and financial strategy</li>
          <li>Drove commercial expansion and effectiveness</li>
          <li>Managed debt and equity financing</li>
          <li>Oversaw path to Nasdaq relisting</li>
          <li>Led accounting, finance, and investor relations</li>
        </ul>
        <h3 className="text-primary montserrat-semibold text-xl mb-2">
          Area Of Expertise
        </h3>
        <ul className="flex flex-col justify-between list-disc montserrat-regular mb-4 sm:mb-9 ml-4">
          <li>Strategic and Operational Planning</li>
          <li>Operational Efficiency & Cost Reduction</li>
          <li>Cross-Functional Leadership & Collaboration</li>
          <li>Debt & Equity Financing</li>
          <li>Corporate Governance & Oversight</li>
          <li>Cash Flow Optimization</li>
        </ul>
        {/* <button className="py-3 px-6 border border-primary rounded-full">
          View Full Resume
        </button> */}
      </>
    ),
  },
  {
    id: 2,
    company: "Invyze Consulting",
    icon: icon1,
    title: "Experience",
    duration: "2023 - 2024",
    role: "President and Founder",
    content: (
      <>
        <h3 className="text-primary montserrat-semibold text-xl mb-4">
          President and Founder, Invyze Consulting (2023 – 2024)
        </h3>
        <p className="montserrat-regular mb-6">
          I bring a diverse financial and operational background to medical
          device companies, delivering both strategic and tactical value. My
          expertise lies in crafting strategic plans, optimizing budgets, and
          driving organizational transformation. My commitment to fostering
          strong organizational cultures ensures long-term success and
          adaptability.
        </p>
        <ul className="montserrat-regular list-disc mb-4 sm:mb-7 ml-4 ">
          <li>Designing and executing comprehensive financial strategies</li>
          <li>
            Leading mergers, acquisitions, and transformational initiatives
          </li>
        </ul>
        <h3 className="text-primary montserrat-semibold text-xl mb-2">
          Area Of Expertise
        </h3>
        <ul className="flex flex-col justify-between list-disc montserrat-regular mb-4 sm:mb-9 ml-4">
          <li>M&A and Transformations</li>
          <li>Financial Growth Modeling</li>
          <li>Investor Relations Strategy</li>
        </ul>
      </>
    ),
  },
  {
    id: 3,
    company: "Orthofix Medical",
    icon: icon3,
    title: "Experience",
    duration: "2014 - 2023",
    role: "Chief Financial Officer",
    content: (
      <>
        <h3 className="text-primary montserrat-semibold text-xl mb-4">
          Chief Financial Officer, Orthofix Medical (2014 –2023)
        </h3>
        <p className="montserrat-regular mb-6">
          With over eight years of executive leadership in spinal implants and
          orthopedics, I have driven organizational transformations delivering
          above-market revenue growth. From the 2015 spinoff of SeaSpine
          Holdings Corporation (Nasdaq: SPNE) to its 2023 merger with Orthofix
          Medical (Nasdaq: OFIX), I increased P&L leverage and optimized supply
          chain efficiency.
        </p>
        <ul className="montserrat-regular list-disc mb-4 sm:mb-7 ml-4 ">
          <li>Driving revenue growth above market benchmarks</li>
          <li>Optimizing supply chain operations for cost efficiency</li>
        </ul>
        <h3 className="text-primary montserrat-semibold text-xl mb-2">
          Area Of Expertise
        </h3>
        <ul className="flex flex-col justify-between list-disc montserrat-regular mb-4 sm:mb-9 ml-4">
          <li>Executive Leadership in Healthcare</li>
          <li>P&L Management</li>
          <li>Financial Reporting & Analysis</li>
          <li>Treasury & Cash Flow Management</li>
          <li>Global Tax & Compliance</li>
        </ul>
      </>
    ),
  },
  {
    id: 4,
    company: "Integra LifeSciences",
    icon: icon4,
    title: "Experience",
    duration: "1999 - 2014",
    role: "Director of Finance",
    content: (
      <>
        <h3 className="text-primary montserrat-semibold text-xl mb-4">
          Integra LifeSciences (1999-2014)
        </h3>
        <p className="montserrat-regular mb-6">
          Over 15 years, I progressed through leadership roles as revenue grew
          from $30 million to over $1 billion, prior to the SeaSpine spinoff. As
          SVP of Global Supply Chain (2012-2014), I optimized operations,
          inventory, and cash flow. As Senior Vice President of Global Supply
          Chain (2012-2014), I streamlined operations, optimized inventory, and
          improved cash investment efficiency
        </p>
        <ul className="montserrat-regular list-disc mb-4 sm:mb-7 ml-4 ">
          <li>Global Supply Chain Strategy & Optimization</li>
          <li>Comprehensive Financial Planning, Reporting & Analysis</li>
        </ul>
        <h3 className="text-primary montserrat-semibold text-xl mb-2">
          Area Of Expertise
        </h3>
        <ul className="flex flex-col justify-between list-disc montserrat-regular mb-4 sm:mb-9 ml-4">
          <li>Cost Reduction Initiatives</li>
          <li>Supply Chain Management</li>
          <li>Sarbanes-Oxley Compliance</li>
        </ul>
      </>
    ),
  },
];
const Experience = () => {
  const [selectedExperience, setSelectedExperience] = useState<ExperienceType>(
    experience[0]
  );
  return (
    <div
      id="experience"
      className="bg-gradient-to-b from-[#173F8417]/10  to-white"
    >
      <div className="max-w-screen-2xl mx-auto px-5 sm:px-20 py-10 sm:py-28">
        <div className="relative mb-9">
          <motion.h3
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
            className="poppins-regular text-primary z-20 relative"
          >
            EXPERIENCE
          </motion.h3>
          <div className="size-16 bg-[#ffff] rounded-full absolute -top-5 -left-5"></div>
        </div>
        <motion.h2
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
          viewport={{ once: true }}
          className="text-4xl sm:text-5xl montserrat-regular text-secondary mb-2"
        >
          A <span className="montserrat-medium">Proven</span> Track <br />
          <span className="montserrat-medium">Record</span> of{" "}
          <span className="montserrat-medium">Success.</span>
        </motion.h2>
        <motion.p
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 1 }}
          viewport={{ once: true }}
          className="montserrat-regular mb-10"
        >
          A CFO with a passion for transforming healthcare and finance. I craft
          strategies, manage risks, and optimize operations to drive growth and
          empower organizations for lasting impact.
        </motion.p>
        <div className="flex flex-col xl:flex-row gap-6">
          <div className="xl:w-[35%] grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-1 gap-4">
            {experience.map((item, index) => (
              <div key={index}>
                <div
                  className={`py-5 rounded-lg flex justify-around items-center cursor-pointer ${
                    selectedExperience.id === item.id
                      ? "bg-primary text-white"
                      : "border text-secondary bg-white"
                  }`}
                  key={item.id}
                  onClick={() => setSelectedExperience(item)}
                >
                  <div className="flex flex-col justify-center items-center text-center">
                    <div
                      className={`rounded-xl mb-2  ${
                        selectedExperience.id === item.id
                          ? "bg-white"
                          : "bg-transparent"
                      }`}
                    >
                      <img
                        src={item.icon}
                        alt=""
                        className="w-24 h-12 object-cover"
                      />
                    </div>
                    <h4 className="montserrat-semibold  flex justify-center text-center">
                      {item.company}
                    </h4>
                  </div>
                  <div className=" flex flex-col justify-between gap-2 montserrat-medium">
                    <p>{item.title}</p>
                    <p>{item.duration}</p>

                    <div
                      className={`border-b-2  ${
                        selectedExperience.id === item.id
                          ? "border-white"
                          : "border-secondary"
                      } `}
                    ></div>
                    <h4>{item.role}</h4>
                  </div>
                </div>
                <div
                  className={`border-l-8 rounded-lg bg-[#E7E9FF] border-primary py-11 px-5 sm:px-16 xl:w-[55%] ${
                    selectedExperience.id === item.id
                      ? "block lg:hidden mt-4"
                      : "hidden"
                  } `}
                >
                  {selectedExperience.content}
                </div>
              </div>
            ))}
          </div>
          <div className="hidden lg:block border-l-8 rounded-lg bg-gradient-to-r from-[#E7E9FF] via-white to-white border-primary py-11 px-5 sm:px-16 xl:w-[55%]">
            {selectedExperience.content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
